import { StoreFeature } from "../../../core/store/types";

export interface PagingType
{
    typeIdentifier: string;
    pageSize: number;
}

export interface NoPagingType extends PagingType
{
    typeIdentifier: "NoPaging";
}

export interface InfiniteScollPagingType extends PagingType
{
    typeIdentifier: "InfiniteScoll";
}

export const pagingType: StoreFeature<PagingType> =
{
    getPostData: (state: PagingType, store) =>
    {
        // TODO: Add support for more paging types as they are added to the system
        let identifierValue = "";
        let page = "first";

        if (store.data.isLoaded && store.data.identifyingFieldValues.at(-1) !== undefined)
        {
            identifierValue = store.data.identifyingFieldValues.at(-1);
            page = "next";
        }

        const pagingPostData =
        {
            pagingTypeIdentifier: state.typeIdentifier,
            pagingType: JSON.stringify(state),
            pagingPage: page,
            pagingIdentifierValue: identifierValue
        };

        return pagingPostData;
    }
};